module.exports = __webpack_public_path__ + "react/fonts/checkbox-false.789cf804.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/checkbox-false.svg
// module id = 1902
// module chunks = 0